import { useEffect } from 'react'

import { useAnalytics } from 'src/lib/hooks/analytics/useAnalytics'
import { useViewerStatus } from 'src/lib/hooks/analytics/useViewerStatus'

import { useCurrentUser } from '../auth/useCurrentUser'

export const useResourcePageView = ({
  ownerEmail,
  ownerId,
  ownerUsername,
  hasPurchased,
}: {
  ownerEmail: string
  ownerId: number
  ownerUsername: string
  hasPurchased?: boolean
}) => {
  const currentUser = useCurrentUser()
  const { page } = useAnalytics()
  const viewerStatus = useViewerStatus(hasPurchased)
  useEffect(() => {
    page({
      isOwner: currentUser.id === ownerId,
      viewerStatus,
      owningCreatorEmail: ownerEmail,
      owningCreatorId: `${ownerId}`,
      owningCreatorUsername: ownerUsername,
    })
  }, [currentUser.id, ownerEmail, ownerId, ownerUsername, page, viewerStatus])
}
